import { useAccess } from "@templates/course/hooks/useAccess";
import AccessMoreTabInstructorCard from "./access/more-tab/InstructorCard";
import { FC, useEffect, useState } from "react";
import { CourseInstructor } from "@types";
import InstructureMobileCard from "./access/more-tab/InstructureMobileCard";

const Instructors: FC = () => {
  const { courseData } = useAccess();

  const [instructors, setInstructors] = useState<CourseInstructor[]>([]);

  useEffect(() => {
    if (courseData?.product?.instructors) {
      setInstructors(courseData?.product?.instructors || []);
    }
  }, [courseData]);

  return (
    <div className="py-6  md:py-8">
      <h2 className="headline-sm md:headline-md text-fds-primary mb-3  md:mb-5">
        درباره مدرس
      </h2>
      <div className="w-full md:flex hidden rounded-12  p-6 course-instructure-section  flex-col">
        {instructors.map((instructorItem, i) => (
          <AccessMoreTabInstructorCard
            key={i}
            dense
            hideTopBorder={i === 0}
            instructorItem={instructorItem}
            isLast={i === instructors.length - 1}
          />
        ))}
      </div>
      <div className="flex md:hidden flex-col gap-2 ">
        {instructors.map((instructorItem, i) => (
          <InstructureMobileCard key={i} instructorItem={instructorItem} />
        ))}
      </div>
    </div>
  );
};

export default Instructors;
